export enum ApiKeyValidationActionType {
  Validate = '@quidproquo-webserver/ApiKeyValidation/Validate',
}
